import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseMagLandings() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateGroup(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("عنوان را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }
  function validate2(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("عنوان را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validate(state, setter) {
    let errorState = {
      articleId: isEmpty(state.articleId),
    };

    setter(errorState);

    if (errorState.articleId) {
      enqueueSnackbar("لطفا مقاله را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const LandingInfo = (landingId, callback) => {
    MyAxios.get(`Admin_Mag_HomeLanding`, {
      headers: {
        HID: landingId,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateLandingInfo = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.put(`Admin_Mag_HomeLanding`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddLandingInfo = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.post(`Admin_Mag_HomeLanding`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  //   /////////////////////////////////////// AddProduct ////////////////////////////////////////

  const AddLandingGroup = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));

    MyAxios.post(`Admin_Mag_HomeLanding/Group`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه مقاله با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateLandingGroup = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.put(`Admin_Mag_HomeLanding/Group`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه مقاله با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteLandingGroup = (GroupID, callback) => {
    const data = new FormData();
    data.append("GroupID", GroupID);
    MyAxios.delete(`Admin_Mag_HomeLanding/Group`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("گروه مقاله با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  //   /////////////////////////////////////// AddProduct ////////////////////////////////////////

  const GetLandingItems = (ID, callback) => {
    MyAxios.get(`Admin_Mag_HomeLanding/Items`, {
      headers: {
        ID: ID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddGroupArticle = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.post(`Admin_Mag_HomeLanding/Article`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("مقاله با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateGroupArticle = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Mag_HomeLanding/Article`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اولویت مقاله با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteGroupArticle = (ItemID, callback) => {
    const data = new FormData();
    data.append("ItemID", ItemID);
    MyAxios.delete(`Admin_Mag_HomeLanding/Article`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("مقاله با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const GetProductsByWord = (search, callback) => {
    MyAxios.get(`Admin_NewOrder/GetProductsByWord?w=${search}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdateHomePageMags = (GroupID, callBack) => {
    const data = new FormData();
    data.append("GroupID", GroupID);
    MyAxios.post(`Admin_Mag_HomeLanding/update`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callBack();
        enqueueSnackbar("به‌روزرسانی مقالات انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const getItemsByGroupID = (landingid, groupID, callback2) => {
    GetLandingItems(landingid, (callback) => {
      callback2(callback.groups.find((m) => m.id == groupID));
    });
  };

  const GetArticleGroups = (callback) => {
    let myPC = {
      PageCount: 1,
    };
    MyAxios.get(`Admin_ArticleGroups?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticles = (search, myPc, callback) => {
    MyAxios.get(`Admin_Articles?w=${search}`, {
      headers: {
        IsPage: false,
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Default",
            sortOrder: "Desc",
            searchColumn: "",
            forceRefresh: true,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticleByID = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    validate,
    validate2,
    GetLandingItems,
    AddGroupArticle,
    UpdateGroupArticle,
    deleteGroupArticle,
    GetProductsByWord,
    UpdateHomePageMags,
    validateGroup,
    getItemsByGroupID,
    LandingInfo,
    UpdateLandingInfo,
    AddLandingInfo,
    AddLandingGroup,
    UpdateLandingGroup,
    deleteLandingGroup,
    GetArticleGroups,
    GetArticles,
    GetArticleByID,
  };
}
